import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  input: {
    maxWidth: '100%',
    marginLeft: '6px',
  },
  text: {
    color: '#f44336',
    marginLeft: 14,
  },
  icon: {
    fontSize: 15,
  },
  errorState: {
    color: '#f44336',
  },
}))

export default useStyles
